// extracted by mini-css-extract-plugin
export default {"link":"ThumbNailsMini_link__-vE9C","image":"ThumbNailsMini_image__UKooQ"};